import { useCallback } from 'react';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { SEARCH_QUERY_KEY } from '../constants';
import { isOnResultsPage } from '../utils/isOnResultsPage';
export const useRemoveSearchQuery = () => {
  const history = useHistory();
  const location = useLocation();
  return useCallback(() => {
    if (!isOnResultsPage(location.pathname)) {
      return;
    }
    const urlSearchParams = new URLSearchParams(location.search);
    urlSearchParams.delete(SEARCH_QUERY_KEY);
    const search = urlSearchParams.size > 0 ? `?${urlSearchParams.toString()}` : '';
    history.replace(Object.assign({}, location, {
      search
    }));
  }, [history, location]);
};